import * as types from "./actionTypes";
import * as userApi from "../../api/usersApi";
import * as apiConfig from "../../api/config";
import { beginApiCall, apiCallError, apiCallUnAuthorised } from "./apiStatusActions";

export function loadUsersSuccess(users) {
    return { type: types.LOAD_USERS_SUCCESS, users };
}

export function loadUserSettingsSuccess(settings) {
    return { type: types.LOAD_SETTINGS_SUCCESS, settings };
}

export function loadUserTimelineSuccess(timeline) {
    return { type: types.LOAD_USER_TIMELINE_SUCCESS, timeline}
}

export function loadUserNetworkFollowers(users) {
    return { type: types.LOAD_NETWORK_FOLLOWERS_SUCCESS, users }
}

export function loadUserNetworkFollowing(users) {
    return { type: types.LOAD_NETWORK_FOLLOWING_SUCCESS, users }
}

export function searchUsers(users) {
    return { type: types.LOAD_USERS_SEARCH_SUCCESS, users }
}

export function loadNotifications(notifications) {
    return { type: types.LOAD_USER_NOTIFICATIONS, notifications }
}

export function notificationsViewed(viewedOn) {
    return { type: types.UPDATE_NOTIFICATIONS_VIEWED, viewedOn }
}


export function notificationOpened(notificationId, openedOn) {
    return { type: types.UPDATE_NOTIFICATION_OPENED, notificationId, openedOn }
}

export function updateUserSearchCriteria(criteria) {
    return { type: types.UPDATE_USERNETWORK_SEARCHCRITERIA, criteria }
}

export function userProfileDeleted() {
    return { type: types.DELETE_USER }
}

export function loadUsersXXX(bearer) {
    return function (dispatch) {
        dispatch(beginApiCall()); 
        return userApi.getUsers(bearer).then(users => {
            dispatch(loadUsersSuccess(users));
        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}

export function deleteUserProfile(id) {
    return function (dispatch) {

        dispatch(beginApiCall());

        return userApi.deleteUser(id).then(result => {
            if (result.userDeleted) {
                dispatch(userProfileDeleted());
            }
            return result;

        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}

export function loadUserProfile(id, bearer) {
    return function (dispatch) {

        dispatch(beginApiCall()); 

        return userApi.getUserData(id, bearer).then(user => {

            //dispatch(loadUserSuccess(user));
            //dispatch(loadUserNetwork(network));

            //settings
            var settings = {
                firstName: user.firstName,
                surname: user.surname,
                email: user.emailAddress,
                location: user.location,
                preferredMeasurementUnits: user.preferredMeasurementUnits.toString(), 
                subscribedMarketingNotification: user.subscribedMarketingNotification, 
                subscribedRideBlogsNotification: user.subscribedRideBlogsNotification,
                approveFollowers: user.approveFollowers,
                avatar: user.avatarAvailable === true ? `${apiConfig.API_URL}user/avatar/${user.userId}.png` : ""
            }

            dispatch(loadUserSettingsSuccess(settings));
            return settings; 

        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}


export function loadSubjectUser(id) {
    return function (dispatch) {

        dispatch(beginApiCall());

        return userApi.getUserSummary(id)
            .then(user => {
                return user;
            }).catch(error => {
                if (error.message === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }

}

export function loadUserTimelineFeed(criteria) {
    return function (dispatch) {

        dispatch(beginApiCall());

        return userApi.getTimelineFeed(criteria).then(timeline => {

            dispatch(loadUserTimelineSuccess(timeline));
           

        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}


export function loadUsers(criteria) {
    return function (dispatch) {

        dispatch(beginApiCall());

        return userApi.searchAllUsers(criteria).then(users => {
            if (!criteria.ownProfile) {
                dispatch(searchUsers(users))
            } else{
                switch (criteria.searchType) {
                    case "followers":
                        dispatch(loadUserNetworkFollowers(users));
                        break;
                    case "following":
                        dispatch(loadUserNetworkFollowing(users));
                        break;
                    case "all":
                        dispatch(searchUsers(users))
                        break;
                }
            }
            dispatch(updateUserSearchCriteria(criteria))
            return users;
        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}

export function loadUserFollowing(criteria) {
    return function (dispatch) {

        dispatch(beginApiCall());

        criteria.searchType = "following";
        return userApi.searchAllUsers(criteria).then(users => {

            dispatch(loadUserNetworkFollowing(users));

        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}

export function searchAllUsers(criteria) {
    return function (dispatch) {

        dispatch(beginApiCall());

        return userApi.searchAllUsers(criteria).then(users => {

            dispatch(searchUsers(users));

        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}

export function getNotifications() {
    return function (dispatch) {
        return userApi.getUserNotifications().then(notifications => {
            dispatch(loadNotifications(notifications));
            return true; 
        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
       
    }
}

export function logNotificationsViewed() {
    var viewedOn = new Date();
    localStorage.setItem('notificationsViewOn', viewedOn) 
    return function (dispatch) {
        dispatch(notificationsViewed(viewedOn));
    }
}

export function logNotificationOpened(notificationId) {
    return function (dispatch) {
        return userApi.logUserNotificationSeen(notificationId).then(() => {
            dispatch(notificationOpened(notificationId, new Date()));
        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });

        
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js